export default __webpack_public_path__ + "static/media/profileimage.fbbcdbd6.svg";